import { Injectable } from '@angular/core';
import { AnalyticsEventService } from './analytics-event.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsBuynowEventService extends AnalyticsEventService {

  constructor() {
    super();
  }

}
